import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const GameDevelopment = () => {
  return <PageTemplate title="Game Development" subtitle="AR, VR & Gaming Solutions" breadcrumb="Applications > Game Development"><div className="content-section"><p>Game development services including AR, VR, and metaverse applications.</p></div></PageTemplate>;
};
export default GameDevelopment; 